import { Component, OnDestroy, OnInit, Type } from '@angular/core';
import { ModalWindowsTypes } from 'src/app/core/enums';
import { CurrentExamService } from 'src/app/services/exam/current-exam.service';
import { ExamModeService } from 'src/app/services/exam/exam-mode.service';
import { ExamService } from 'src/app/services/restrictions/exam.service';
import { IModalWindow, ISetOptions, IGetClass } from 'src/app/utils/interfaces/modal-dialog.interface';
import { ExamDocumentType } from 'src/app/services/exam/enums/document-type.enum';
import { ReportExamService } from 'src/app/services/exam/report-exam.service';
import { ReportLogLevel } from 'src/app/services/exam/enums/report-level.enum';
import { of, Subject } from 'rxjs';
import { catchError, exhaustMap, takeUntil, tap } from 'rxjs/operators';
import { ModalWindowService } from 'src/app/services/ui/modal-window.service';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'asg-access-code-dialog',
    templateUrl: './access-code-dialog.component.html',
    styleUrls: ['./access-code-dialog.component.scss'],
    standalone: true,
    imports: [FormsModule, TranslateModule]
})
export class AccessCodeDialogComponent implements OnInit, OnDestroy, IModalWindow, ISetOptions, IGetClass {
  CODE_REQUIRED = 'EXAM_UNLOCK_DIALOG.CODE_REQUIRED';
  error = '';
  accessCode = '';
  click$: Subject<void> = new Subject();
  loading: boolean = false;
  private destroy$: Subject<void> = new Subject();

  constructor(
    private readonly examService: ExamService,
    private readonly examModeService: ExamModeService,
    private readonly currentExamService: CurrentExamService,
    private readonly reportExamService: ReportExamService,
    private readonly modalService: ModalWindowService
  ) { }

  ngOnInit(): void {
    this.click$.pipe(
      tap(() => {
        // start retrieving exam information
        this.modalService.disable();
        this.loading = true;
      }),
      takeUntil(this.destroy$),
      exhaustMap(() => this.start()),
      catchError((error) => of(error))
    )
    .subscribe(() => {
      // exam information received and processed
      this.modalService.enable();
      this.loading = false;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getWindowType(): Type<IModalWindow> {
    return AccessCodeDialogComponent;
  }

  getWindowEnumType(): ModalWindowsTypes {
    return ModalWindowsTypes.ENTER_ACCESS_CODE_DIALOG;
  }

  getInstanceOf(type: string): IModalWindow | ISetOptions | IGetClass | null {
    switch (type) {
      case 'IModalWindow':
        return this as unknown as IModalWindow;
      case 'ISetOptions':
        return this as unknown as ISetOptions;
      case 'IGetClass':
        return this as unknown as IGetClass;
      default: return null;
    }
  }

  setOptions(options: any): void {
    options = options || {};
  }

  getClass(): string {
    return 'enter-access-code-dlg';
  }

  private async start(): Promise<void> {
    if (!!!this.accessCode) {
      this.error = this.CODE_REQUIRED;
      return;
    }

    // catch needed to continue the function, otherwise it's not seen as completed
    let result = await this.examService.checkAccessCode(this.accessCode).catch(() => {});

    if (result) {
     
      const examData = result;
      const examFile = examData.examFiles.filter(x => x.documentType == ExamDocumentType.Exam)[0]; 

      const file = await this.examModeService.downloadExamDocument(examData.id, examFile);
      if (file === undefined) {
        throw new Error("exam file is not found");
      }
      else {
        this.currentExamService.setExamMetadata(examData);
        this.currentExamService.setExamInitialDocument(file);
        this.examModeService.startExam();
        this.reportExamService.sendTemplateMessageReport(ReportLogLevel.Information, 'WOLAND.REPORT_TEMPLATES.ACCESS_CODE_TEMPLATE');
      }
    }
  }

}
